export default {
  version: 'master',
  compilation: '297839'
}



//////////////////
// WEBPACK FOOTER
// ./version.js
// module id = 1478
// module chunks = 22